import { render } from "./Platformcyzq.vue?vue&type=template&id=d4f141a0&scoped=true"
import script from "./Platformcyzq.vue?vue&type=script&lang=js"
export * from "./Platformcyzq.vue?vue&type=script&lang=js"

import "./Platformcyzq.vue?vue&type=style&index=0&id=d4f141a0&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f141a0"]])

export default __exports__